import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;
let isLoggingOut = false;

export function setLoggingOut(value: boolean) {
    isLoggingOut = value;
}

export async function initSocket(getToken: any): Promise<Socket | null> {
    if (socket) return socket;
    if (isLoggingOut) return null;

    let hasRetriedAuth = false;

    try {
        const { access_token } = await getToken();

        socket = io(process.env.REACT_APP_WS_URL, {
            transports: ["websocket"],
            auth: { token: access_token },
            reconnection: true,
            reconnectionAttempts: 3,
            reconnectionDelay: 2000,
            reconnectionDelayMax: 2000,
        });

        socket.on("connect", () => {
            console.log("WS connected");
            hasRetriedAuth = false;
        });

        socket.on("connect_error", async (err: any) => {
            console.error("WS error:", err.message);

            const isAuthError =
                err.message.includes("Unauthorized") ||
                err.message.includes("Invalid Token") ||
                err.message.toLowerCase().includes("expired") ||
                err.message.toLowerCase().includes("unauthorized");

            if (isAuthError && !hasRetriedAuth) {
                hasRetriedAuth = true;

                try {
                    const { access_token } = await getToken();
                    if (socket) {
                        socket.auth = { token: access_token };
                        socket.connect();
                    }
                } catch (e) {
                    console.error("Failed to get token during reconnect:", e);
                    disconnectSocket();
                    window.location.href = "/session-expired";
                }
            }
        });

        socket.onAny((event: string, ...args: any[]) => {
            if (event !== "recommendation-ready" && event !== "recommendation-error") {
                console.log(`Unspecified WebSocket message received - Event: ${event}`, args);
            }
        });

        return socket;

    } catch (err: any) {
        if (err?.error === 'missing_refresh_token' || isLoggingOut) {
            console.debug("Socket init skipped: User is logging out or missing refresh token");
            return null;
        }
        console.error("Socket init error:", err);
        socket = null;
        return null;
    }
}

export function getSocket() {
    return socket;
}

export function disconnectSocket() {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
}
